import { render } from "./ServiziView.vue?vue&type=template&id=7cac1a6e&scoped=true"
import script from "./ServiziView.vue?vue&type=script&lang=js"
export * from "./ServiziView.vue?vue&type=script&lang=js"

import "./ServiziView.vue?vue&type=style&index=0&id=7cac1a6e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cac1a6e"]])

export default __exports__